import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AnimatedLoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!email) newErrors.email = "Email is required";
    if (!password) newErrors.password = "Password is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const loginData = { email, password };
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/admin/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        });

        const result = await response.json();
       // Login.js
if (response.ok) {
  const { token } = result; // Assuming the token is returned in the response
  sessionStorage.setItem('authToken', token); // Store the token
  toast.success("Login successful! Redirecting to the dashboard...");
  navigate("/admin/dashboard");
} else {
  toast.error("Invalid credentials. Please try again.");
}
      } catch (error) {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1500); // Welcome message now displays after 1.5 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex justify-center items-center h-screen px-4 sm:px-8">
      <div className="relative w-full max-w-[900px] h-[500px] md:h-[550px] perspective-1000">
        {/* Welcome Cover */}
        {!isOpen && (
          <div
            className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-400 text-white flex items-center justify-center text-2xl sm:text-4xl font-bold rounded-md shadow-lg transform transition-transform duration-1000"
            style={{
              transform: isOpen ? "rotateY(-180deg)" : "rotateY(0deg)",
              backfaceVisibility: "hidden",
            }}
          >
            Welcome to Login
          </div>
        )}

        {/* Book Content */}
        <div
          className="absolute inset-0 bg-white shadow-lg rounded-md transform transition-transform duration-1000"
          style={{
            transform: isOpen ? "rotateY(0deg)" : "rotateY(180deg)",
            backfaceVisibility: "hidden",
          }}
        >
          <div className="flex flex-col md:flex-row h-full">
            {/* Left Page: Image */}
            <div
              className="w-full md:w-1/2 bg-cover bg-center rounded-t-md md:rounded-l-md md:rounded-tr-none"
              style={{
                backgroundImage:
                  'url("https://media.istockphoto.com/id/1470544060/photo/group-of-university-students-e-learning-on-laptop-at-campus.jpg?s=612x612&w=0&k=20&c=cwuT0WSg2xzQ0MhFzt2EbIL33IcS40-Mb3htuy9B0v0=")',
              }}
            />
            {/* Right Page: Form */}
            <div className="w-full md:w-1/2 bg-gradient-to-l from-teal-500 via-teal-300 to-teal-300 p-6 sm:p-10 flex flex-col justify-center items-center rounded-b-md md:rounded-r-md md:rounded-bl-none">
              <h2 className="text-2xl sm:text-3xl font-bold text-black mb-6 text-center">
                College Login
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4 w-full max-w-sm">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-black text-sm font-semibold mb-2"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className={`block w-full p-3 text-sm text-gray-700 border border-teal-500 rounded-md focus:outline-none focus:ring focus:ring-teal-500 ${errors.email ? "border-red-500" : ""
                      }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="password"
                    className="block text-black text-sm font-semibold mb-2"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className={`block w-full p-3 text-sm text-gray-700 border border-teal-500 rounded-md focus:outline-none focus:ring focus:ring-teal-500 ${errors.password ? "border-red-500" : ""
                      }`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                  />
                  {errors.password && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>
                <div className="flex flex-col items-center space-y-4">
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 text-white font-bold py-3 px-4 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-teal-300"
                  >
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
      `}</style>
    </div>
  );
}

export default AnimatedLoginForm;
